import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ListView } from './views/ListView';
import { DetailView } from './views/DetailView';
import { FormView } from './views/FormView';

export const routes: RouteObject[] = [
  {
    path: '/terms-and-conditions',
    element: <ListView />,
  },
  {
    path: '/terms-and-conditions/create',
    element: <FormView />,
  },
  {
    path: '/terms-and-conditions/:id',
    element: <DetailView />,
  },
  {
    path: '/terms-and-conditions/:id/edit',
    element: <FormView />,
  },
];
